var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',{class:[
    'l-rblock',
    'l-quick-bi-viewer',
    { 'l-quick-bi-app-viewer': _vm.isApp },
  ]},[_c('div',{staticClass:"l-rblock l-quick-bi-app-viewer-inner l-overflow-y"},[_c('grid-layout',{attrs:{"layout":_vm.layout,"col-num":_vm.isApp?12:120,"row-height":_vm.isApp?60:1,"is-draggable":false,"is-resizable":false}},_vm._l((_vm.layout),function(item){return _c('grid-item',{key:item.i,attrs:{"x":item.x,"y":item.y,"w":item.w,"h":item.h,"i":item.i}},[_c('bi-item',{attrs:{"data":item,"isPreview":_vm.isPreview}})],1)}),1)],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }